import { render } from "./InvoiceDetailsPrint.vue?vue&type=template&id=fbdee27a&scoped=true"
import script from "./InvoiceDetailsPrint.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsPrint.vue?vue&type=script&lang=js"

import "./InvoiceDetailsPrint.vue?vue&type=style&index=0&id=fbdee27a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdee27a"]])

export default __exports__